module.exports = __webpack_public_path__ + "static/image/bg_card@2x.png";